// extracted by mini-css-extract-plugin
export default {"icon":"PermalinkButton-icon-0e640f1274f0960aa67d6386824c2a71"};